import { StageDef } from '../automationMachineInterfaces'
import { REDDIT_AUTOMATION_STAGE_STATUSES } from './redditAutomationStageStatuses'
import * as redditUrls from './redditUrls'
import { RedditSettingKey } from '../../recommendations/recommendationSettingsKeys'
import * as enums from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'
import { getOptionalElement } from '../utils'

const getCurrentValueFn = (key: string) =>
  getCurrentValueFnFromKey(key, (value) => value)

const getIsFulfilledFn = (key: string) =>
  getIsFulfilledFnFromKey(key, (value) => value === true)

async function getHasApps(): Promise<boolean | null> {
  const listOfApps = await getOptionalElement<HTMLElement>(
    document,
    `//div[@id="developed-apps"]/ul`,
  )
  return listOfApps?.hasChildNodes() ?? null
}

const gatherStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: `INIT_REDDIT_SETTING_${RedditSettingKey.THIRD_PARTY_ACCESS}`,
    status: REDDIT_AUTOMATION_STAGE_STATUSES.CHANGING_PAGES,
    url: redditUrls.homeUrl,
    action: async () => {
      window.location.assign(redditUrls.appsUrl)
    },
  },
  {
    type: enums.StageType.ACTION,
    key: `GATHER_REDDIT_SETTING_${RedditSettingKey.THIRD_PARTY_ACCESS}`,
    status: REDDIT_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: redditUrls.appsUrl,
    action: async (_machineContext, userContext) => {
      const hasApps = await getHasApps()
      await userContext.updateStoredInitialValues(
        {
          [RedditSettingKey.THIRD_PARTY_ACCESS]: !hasApps,
        },
        enums.RedditRecommendationKey.REDDIT_THIRD_PARTY_ACCESS,
      )
    },
  },
]

const getCantUndoFn = () => defaultCantUndoFn

const getIsDisabledFn = () => defaultIsDisabledFn

const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

const updateStageDefs: StageDef[] = []

const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
